import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ImportCertificateHolder from '../../../../../shared/Cis/CertificateHolders/Import/ImportCertificateHolder';
import reducer, { defaultState, updateFieldCreator, setErrorsCreator } from './reducer';
import { useReducer } from 'react';
import { importDataCreator } from '../../../../../store/actionsCreators';

const ImportIpmaCertificateHolder = ({ certificationBodies, importData, importErrors }) => {
  const [state, dispatch] = useReducer(reducer, defaultState);

  return (
    <ImportCertificateHolder
      type="ipma"
      certificationBodies={certificationBodies}
      state={state}
      dispatch={dispatch}
      updateFieldCreator={updateFieldCreator}
      setErrorsCreator={setErrorsCreator}
      importData={importData}
      importErrors={importErrors}
    />
  );
};

ImportIpmaCertificateHolder.propTypes = {
  certificationBodies: PropTypes.arrayOf(PropTypes.object).isRequired,
};

const mapStateToProps = ({ globals }) => ({
  certificationBodies: globals.cis.certificationBodies,
  importErrors: globals.cis.importErrors,
});

const mapDispatchToProps = (dispatch) => ({
  importData: (params) => dispatch(importDataCreator(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ImportIpmaCertificateHolder);
